import { Button, ModalV2 } from '@skand/ui';

export interface ColorInputProps {
  open: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  annotationName?: string;
}

export const DeletionModal = ({ open, annotationName, onCancel, onSubmit }: ColorInputProps) => {
  return (
    <ModalV2 open={open}>
      <div className="mt-1 flex flex-col gap-6">
        <p className="color-neutral-800 typo-text-m">Delete Annotation</p>
        <p className="color-neutral-800 typo-text-s">
          {`Are you sure you want to delete the annotation ${annotationName}?`}
        </p>
      </div>
      <div className="mt-4 w-full flex gap-2">
        <Button className="w-full cursor-pointer" onClick={onCancel} size="s">
          Cancel
        </Button>
        <Button className="w-full cursor-pointer" filled onClick={onSubmit} primary size="s">
          Delete Annotation
        </Button>
      </div>
    </ModalV2>
  );
};
